import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'transactionRuleReferenceText',
    standalone: true
})
export class TransactionRuleReferenceTextPipe implements PipeTransform {

    transform(field: string): string {
        switch (field) {
            case 'reference':
                return 'Verwendungszweck';
            case 'name':
                return 'Name';
            case 'amount':
                return 'Betrag';
            case 'date':
                return 'Datum';
            default:
                return 'Unbekannt';
        }
    }

}
